export const gestorPodeCadastrarEditar = (ajustes) =>
    Number(ajustes?.gestor_pode_cadastrar_editar_usuario ?? 1) !== 0;

export const gestorPodeAtribuirCursos = (ajustes) =>
    Number(ajustes?.gestor_pode_atribuir_cursos ?? 1) !== 0;

export const gestorPodeResetarSenha = (ajustes) =>
    Number(ajustes?.gestor_pode_resetar_senha ?? 1) !== 0;

export const gestorVerTodosCursos = (ajustes) =>
    Number(ajustes?.gestor_ver_todos_cursos ?? 1) !== 0;

/** Exibir campo de cursos no cadastro/edição de aluno para Gestor. */
export const gestorMostrarCampoCursos = (ajustes, nivel) => {
    if (nivel !== 'Gestor') {
        return true;
    }
    if (gestorPodeAtribuirCursos(ajustes)) {
        return true;
    }
    if (!gestorVerTodosCursos(ajustes) && gestorPodeCadastrarEditar(ajustes)) {
        return true;
    }
    return false;
};

/** Admin/RH vincula cursos ao perfil Gestor (permissao_cursos) quando o gestor não vê todos os cursos. */
export const adminPodeVincularCursosAoGestor = (ajustes, nivelLogado) =>
    (nivelLogado === 'Administrador' || nivelLogado === 'RH')
    && !gestorVerTodosCursos(ajustes);

/** Campo cursos no modal de usuário (cadastro/edição). */
export const exibirCampoCursosNoFormulario = (ajustes, nivelLogado, tipoUsuario) => {
    const tipo = tipoUsuario?.value || tipoUsuario?.label || tipoUsuario;

    if (tipo === 'Aluno') {
        return nivelLogado !== 'Gestor' || gestorMostrarCampoCursos(ajustes, nivelLogado);
    }

    if (tipo === 'Gestor') {
        return adminPodeVincularCursosAoGestor(ajustes, nivelLogado);
    }

    return false;
};

export const cursosObrigatoriosNoFormulario = (ajustes, nivelLogado, tipoUsuario) => {
    const tipo = tipoUsuario?.value || tipoUsuario?.label || tipoUsuario;
    if (tipo !== 'Aluno') {
        return false;
    }
    return nivelLogado !== 'Gestor' || gestorMostrarCampoCursos(ajustes, nivelLogado);
};

/** Gestor sem edição completa, mas pode abrir modal só para cursos. */
export const gestorModoSomenteCursos = (ajustes, nivel) =>
    nivel === 'Gestor'
    && !gestorPodeCadastrarEditar(ajustes)
    && gestorMostrarCampoCursos(ajustes, nivel);
